module.exports = __webpack_public_path__ + "static/media/IMG_7618-min.4062eed1.jpg";